import AddPayment from "./AddPayment.view";

export default AddPayment;
